<template>
  <div id="bucket">
    <button class="btn btn-success" @click="addBucket=true">
      <i class="fa fa-plus"></i>
    </button>
    <dx-data-grid
      :data-source="dataSource"
      :columns="columns"
      :loadPanel="loadPanel"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-min-width="20"
      :show-borders="true"
      :remote-operations="remote"
      :allow-filter="true"
      :repaint-changes-only="true"
      :filterRow="filterRow"
      :noDataText="$i18n.t('tabla.nodata')"
      :columnAutoWidth="true"
      :height="500"
      :columnFixing="columnFixing"
      :stateStoring="storage"
      :columnChooser="columnChooser"
      :grouping="grouping"
      :sorting="sorting"
    >
      <dx-paging :page-size="50" :visible="true" :page-index="0" />
      <dx-pager :show-page-size-selector="true" :visible="true" :show-info="true" />
    </dx-data-grid>
    <modal-edit type="bucket" :file="recursoEdit" v-if="recursoEdit"></modal-edit>
    <agregar-bucket v-if="addBucket"></agregar-bucket>
  </div>
</template>
<script>
import { DxDataGrid, DxPager, DxPaging } from "devextreme-vue/data-grid";
import $ from "jquery";
import CustomStore from "devextreme/data/custom_store";
import modalEdit from "../components/modalEdit";
import agregarBucket from "../components/agregarBucket";
import notify from 'devextreme/ui/notify';

export default {
  name: "buckets",
  components: {
    DxPager,
    DxPaging,
    DxDataGrid,
    modalEdit,
    agregarBucket
  },
  data() {
    return {
      dataSource: [],
      addBucket: false,
      loadPanel: {
        text: this.$i18n.t("modal.loading")
      },
      recursoEdit: undefined,
      sorting: {
        ascendingText: this.$i18n.t("tabla.ord_asc"),
        clearText: this.$i18n.t("tabla.clearText"),
        descendingText: this.$i18n.t("tabla.descendingText")
      },
      columnChooser: {
        allowSearch: false,
        enabled: true,
        height: 260,
        mode: "select",
        searchTimeout: 500,
        title: "Columnas a mostrar..",
        width: 250
      },
      storage: {
        enabled: true,
        type: "localStorage",
        storageKey: "grillaArticulos"
      },
      filterRow: {
        applyFilterText: this.$i18n.t("tabla.applyFilterText"),
        betweenEndText: this.$i18n.t("tabla.betweenEndText"),
        betweenStartText: this.$i18n.t("tabla.betweenStartText"),
        operationDescriptions: {
          between: this.$i18n.t("tabla.between"),
          contains: this.$i18n.t("tabla.contains"),
          endsWith: this.$i18n.t("tabla.endsWith"),
          equal: this.$i18n.t("tabla.equal"),
          greaterThan: this.$i18n.t("tabla.greaterThan"),
          greaterThanOrEqual: this.$i18n.t("tabla.greaterThanOrEqual"),
          lessThan: this.$i18n.t("tabla.lessThan"),
          lessThanOrEqual: this.$i18n.t("tabla.lessThanOrEqual"),
          notContains: this.$i18n.t("tabla.notContains"),
          notEqual: this.$i18n.t("tabla.notEqual"),
          startsWith: this.$i18n.t("tabla.startsWith")
        },
        resetOperationText: this.$i18n.t("tabla.reset"),
        visible: true,
        applyFilter: "auto"
      },
      grouping: {
        allowCollapsing: true,
        contextMenuEnabled: true,
        expandMode: "rowClick",
        texts: {
          groupByThisColumn: this.$i18n.t("tabla.groupByThisColumn"),
          groupContinuedMessage: this.$i18n.t("tabla.groupContinuedMessage"),
          groupContinuesMessage: this.$i18n.t("tabla.groupContinuesMessage"),
          ungroup: this.$i18n.t("tabla.ungroup"),
          ungroupAll: this.$i18n.t("tabla.ungroupAll")
        }
      },
      columnFixing: {
        enabled: true,
        texts: {
          fix: this.$i18n.t("tabla.fix"),
          leftPosition: this.$i18n.t("tabla.leftPosition"),
          rightPosition: this.$i18n.t("tabla.rightPosition"),
          unfix: this.$i18n.t("tabla.unfix")
        }
      },
      columns: [
        {
          caption: "_id",
          dataField: "_id",
          allowFiltering: false
        },
        {
          caption: this.$i18n.t("contenedor.name"),
          dataField: "nombre"
        },
        {
          caption: this.$i18n.t("contenedor.note"),
          dataField: "nota"
        },
        {
          caption: this.$i18n.t("contenedor.created_at"),
          dataField: "created_at",
          dataType: "date",
          format: "dd/MM/yyyy HH:mm"
        },
        {
          caption: this.$i18n.t("contenedor.updated_at"),
          dataField: "updated_at",
          dataType: "date",
          format: "dd/MM/yyyy HH:mm"
        },
        {
          caption: this.$i18n.t("edit"),
          type: "buttons",
          buttons: [
            {
              icon: "fas fa-edit",
              hint: this.$i18n.t("edit"),
              text: this.$i18n.t("edit"),
              cssClass: "text-success editar",
              onClick: e => {
                this.recursoEdit = e.row.data;
              }
            },
            {
              icon: "fas fa-info",
              hint: "ver",
              cssClass: "buttonInfo editar",
              onClick: e => {
                this.$router.push({
                  name: "previewArticulo",
                  params: { _id: e.row.data._id, lang: this.$i18n.locale }
                });
              }
            }
          ]
        }
      ],
      remote: { paging: true, sorting: true }
    };
  },
  methods: {
    consultaBuckets() {
      var self = this;

      self.dataSource = {
        store: new CustomStore({
          type: "odata",
          key: "_id",
          load: function(loadOptions) {
            let params = "?";
            // let filtros = "";

            // loadOptions.take = size;
            // loadOptions.skip = offset;

            // if (loadOptions.take == 'undefined' || loadOptions.take == undefined)
            //   loadOptions.take = limit
            // if (loadOptions.skip == 'undefined' || loadOptions.skip == undefined)
            //   loadOptions.skip = offset

            var deferred = $.Deferred();
            params += `&size=${loadOptions.take || 25}`;
            params += `&page=${loadOptions.skip / loadOptions.take + 1 || 1}`;
            // let created_at;
            // let updated_at;
            // if (loadOptions.sort) {
            //   params += `&sort=`;
            //   loadOptions.sort.forEach(p => {
            //     params += `${p.selector}.${p.desc ? "desc" : "asc"}`;
            //   });
            // }
            // if (loadOptions.filter) {
            //   if (typeof loadOptions.filter[0] == "string") {
            //     params += `&${loadOptions.filter[0]}=${loadOptions.filter.filterValue}`;
            //   }
            //   loadOptions.filter.forEach(p => {
            //     if (typeof p != "string") {
            //       if (p[0] == "created_at") {
            //         if (created_at == undefined) {
            //           created_at = `&${p[0]}_start=${moment(p[2]).toISOString()}`;
            //         } else {
            //           created_at += `&${p[0]}_end=${moment(p[2]).toISOString()}`;
            //         }
            //       } else if (p[0] == "updated_at") {
            //         if (updated_at == undefined) {
            //           updated_at = `&${p[0]}_start=${moment(p[2]).toISOString()}`;
            //         } else {
            //           updated_at += `&${p[0]}_end=${moment(p[2]).toISOString()}`;
            //         }
            //       } else {
            //         params += `&${p[0]}=${p.filterValue}`;
            //       }
            //     }
            //   });
            // }
            // if (updated_at) {
            //   params += updated_at;
            // }
            // if (created_at) {
            //   params += created_at;
            // }
            // console.log(created_at, updated_at)
            // params += '&limit=' + loadOptions.take;
            // params += '&offset=' + loadOptions.skip;
            self.$http
              .get(`${self.$store.getters.ws.api_recursos}/buckets${params}`)
              .then(async response => {
                // self.$http.get(`${ self.baseUrl } ${ self.sellerId } ${ self.addedUrl } ${ self.accessToken } ${ self.scrollUrl } ${ self.scrollId } `).then(function (response) {
                // self.$store.getters.tokenMl
                self.page = response.data.page.page;
                // limit = response.data.limit;
                // offset = response.data.offset;
                // console.log(response.data.items.length)
                await deferred.resolve({
                  data: response.data.content.map(x => x),
                  totalCount: response.data.page.total,
                  totalPages: response.data.page.pages
                });
              })
              .catch(err => {
                notify(err, "warning", 5000);
              });
            return deferred.promise();
          }
        })
      };
    }
  },
  created() {
    this.consultaBuckets();
  }
};
</script>
<style>
#bucket {
  margin: 4%;
  margin-top: 0px;
}
.editar {
  margin: 0px 5px 0px 5px !important;
}
</style>